import React, { Component } from 'react'
import { Col, Row, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle,Table} from 'reactstrap'
import CustomersServices from './../../services/customerServices/CustomersServices'
import Services from './../../services/Services'
import { LoadingSpinner } from './../../components'

export default class CustomerHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      history:[],
      noData:false
    }
  }

  componentDidMount(){
    console.log(this.props.customer);
    this.getHistory()
  }


  getHistory(){
    this.setState({loading:true})
    CustomersServices.getHistory(this.props.customer.id, (res)=>{
      this.setState({loading:false, history:res.data.customers, noData:res.data.customers.length==0},()=>console.log(res))
    })
  }


  render(){
    return(
      <div>
        {this.state.history!=''?(
          <Row>
            <Col md='1'/>
            <Col md="10">
              <Table hover bordered striped responsive size="md">
                <thead>
                  <tr>
                    <th style={{textAlign:'center'}} width='15%'>Name</th>
                    <th style={{textAlign:'center'}} width='25%'>Actions</th>
                    <th style={{textAlign:'center'}} width='25%'>Date and Time</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.history.map((item, index)=>(
                    <tr key={index}>
                      <td style={{textAlign:'center'}}>{item.actionMaker.name}</td>
                      <td style={{textAlign:'center'}}>{item.action.action}</td>
                      <td style={{textAlign:'center'}}>{item.createdAt}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
            <Col md='1'/>
          </Row>
        ):null}

        {this.state.noData?(
          <p style={{textAlign:'center', fontSize:16, color:'#777', marginTop:40}}>There is no actions taken</p>
        ):null}

        <LoadingSpinner loading={this.state.loading}/>
      </div>
    )
  }

}
